import React from "react";
import Header from "./Header";
import "../CSS/Global.css";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="legal-page-shell">
        <div className="privacy-policy legal-doc">
          <h1>Privacy Policy</h1>
          <p className="legal-doc-meta">
            This policy describes how <strong>Filmekee.com</strong> (“Filmekee”, “we”) collects, uses, stores, and protects personal information when you use our marketplace for film and production-related bookings, equipment, and vendor services.
          </p>

          <h2>1. Information we collect</h2>
          <p>
            <strong>Account &amp; profile:</strong> name, email, phone, business details (for vendors), and profile or storefront information you choose to add.
          </p>
          <p>
            <strong>Transactions:</strong> order and booking identifiers, cart details, booking dates or ranges, delivery or pickup information, payment status (payment card data is handled by our payment partners; we do not store full card numbers on our servers).
          </p>
          <p>
            <strong>Usage &amp; device:</strong> approximate location (if you allow), device type, IP address, and cookies or similar technologies used for security, preferences, and analytics.
          </p>
          <p>
            <strong>Communications:</strong> messages you send through in-app chat or email to support, and records needed to resolve disputes.
          </p>

          <h2>2. How we use information</h2>
          <p>
            We use data to create and manage accounts, process bookings and payments, connect customers with vendors, send transactional notices (confirmations, reminders), improve the product, detect fraud and abuse, comply with law, and—where you opt in—marketing relevant to Filmekee.
          </p>

          <h2>3. Sharing</h2>
          <p>
            We share information with vendors as needed to fulfil your booking (e.g. name, contact, address, booking window). We use service providers (hosting, payments, analytics, email) under contracts that require protection of personal data. We may disclose information if required by law or to protect rights and safety.
          </p>

          <h2>4. Retention</h2>
          <p>
            We keep information for as long as your account is active and as needed for legal, tax, and dispute-resolution purposes. You may request deletion subject to exceptions (e.g. completed transactions we must retain).
          </p>

          <h2>5. Security</h2>
          <p>
            We use administrative, technical, and organisational measures—including encryption in transit where appropriate—to protect data. No online service is perfectly secure; please use a strong password and contact us if you suspect unauthorised access.
          </p>

          <h2>6. Your rights</h2>
          <p>
            Depending on your region, you may have rights to access, correct, delete, or export your data, or to object to certain processing. Contact us to exercise these rights. You may opt out of marketing emails via the unsubscribe link where offered.
          </p>

          <h2>7. Children</h2>
          <p>
            Filmekee is not directed at children under 16. We do not knowingly collect personal data from children.
          </p>

          <h2>8. International transfers</h2>
          <p>
            If you use Filmekee from outside India, your data may be processed in India or other countries where we or our providers operate. We take steps consistent with applicable law to safeguard transfers.
          </p>

          <h2>9. Contact</h2>
          <p>
            Questions about this policy: <strong>privacy@filmekee.com</strong> (update to your official privacy contact when live).
          </p>

          <p>
            <strong>Last updated:</strong> 31 March 2026
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
